import * as React from "react";

function Logo(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			viewBox="0 0 95 95"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M47.5 0C21.267 0 0 21.267 0 47.5a47.291 47.291 0 009.657 28.713c-.96-2.577-.905-5.48.166-8.71a13.99 13.99 0 012.144-4.063 12.577 12.577 0 013.242-2.998c1.3-.816 2.7-1.32 4.199-1.51 1.536-.208 3.133-.037 4.792.514 1.152.382 2.146.774 2.98 1.176a8.32 8.32 0 012.279 1.458c1.65 1.515 2.07 3.496 1.259 5.942-.336 1.012-.887 2.109-1.654 3.29-.75-1.217-1.464-2.124-2.14-2.723-.609-.514-1.377-.925-2.305-1.233-1.912-.634-3.636-.472-5.17.485a5.842 5.842 0 00-1.797 1.605 8.229 8.229 0 00-1.177 2.278c-.68 2.052-.528 3.85.458 5.395a5.77 5.77 0 001.477 1.613 6.71 6.71 0 001.913 1.01c1.012.335 1.944.488 2.797.459.88-.02 1.765-.288 2.654-.805 1.835-1.108 3.934-3.626 6.298-7.554l34.006-57.21c-4.412.316-8.222 1.736-11.432 4.26-3.172 2.506-5.518 6.05-7.038 10.633-.615 1.856-.88 3.36-.794 4.512-.01.403.024.773.1 1.11.047.234.038.45-.028.646-3.12-1.035-5.193-2.41-6.216-4.122-1.155-1.881-1.233-4.326-.236-7.334.625-1.884 1.649-3.604 3.07-5.162 1.431-1.585 3.176-2.988 5.235-4.208 1.947-1.165 4.124-2.128 6.53-2.89a38.58 38.58 0 017.6-1.599c5.497-.58 10.608-.085 15.331 1.481l1.29.428C71.05 4.692 59.823 0 47.5 0zm33.651 13.976L48.369 70.132c-1.869 3.188-3.809 5.884-5.82 8.088-1.992 2.242-4.139 3.963-6.441 5.166-2.453 1.277-5.117 1.97-7.993 2.077-2.885.135-6.07-.375-9.557-1.532a19.627 19.627 0 01-2.974-1.25C24.017 90.335 35.214 95 47.5 95 73.734 95 95 73.734 95 47.5c0-13.084-5.29-24.933-13.849-33.524z"
				fill="#F14668"
			/>
		</svg>
	);
}

export default Logo;
